"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Windows = exports.useWindowsFunctions = exports.useWindowsState = exports.WindowsProvider = void 0;
const icons_1 = require("@material-ui/icons");
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const WindowsStateContext = react_1.default.createContext([]);
const MISSING_WINDOWS_PROVIDER = () => {
    throw Error('missing WindowsProvider');
};
const WindowsFunctionsContext = react_1.default.createContext({
    open: MISSING_WINDOWS_PROVIDER,
    close: MISSING_WINDOWS_PROVIDER,
    toggleCollapse: MISSING_WINDOWS_PROVIDER,
});
/** Provides Windows React contexts, so that you can use the hooks and `Windows`. */
const WindowsProvider = ({ children }) => {
    const [state, dispatch] = react_1.useReducer(reducer, { windows: [], nextId: 0 });
    return (react_1.default.createElement(WindowsFunctionsContext.Provider, { value: {
            open: (window) => new Promise((resolve) => {
                dispatch({
                    type: 'open',
                    window,
                    windowIdCallback: resolve,
                });
            }),
            close: (windowId) => dispatch({ type: 'close', windowId }),
            toggleCollapse: (windowId) => dispatch({ type: 'toggleCollapse', windowId }),
        } },
        react_1.default.createElement(WindowsStateContext.Provider, { value: state.windows }, children)));
};
exports.WindowsProvider = WindowsProvider;
/** Gets the current windows state. You probably don't need this. */
function useWindowsState() {
    return react_1.useContext(WindowsStateContext);
}
exports.useWindowsState = useWindowsState;
/** Gets functions for manipulating windows. You'll probably need this. */
function useWindowsFunctions() {
    return react_1.useContext(WindowsFunctionsContext);
}
exports.useWindowsFunctions = useWindowsFunctions;
/** Renders the floating windows. See documentation for where to place. */
const Windows = () => {
    const windows = useWindowsState();
    const { close, toggleCollapse } = useWindowsFunctions();
    return (react_1.default.createElement("div", { className: "absolute bottom-0 right-0 flex flex-row-reverse items-end pointer-events-none" }, windows.map((window) => (react_1.default.createElement(Window, { key: window.id, window: window, onToggleCollapse: toggleCollapse, onClose: close })))));
};
exports.Windows = Windows;
const Window = ({ window, onToggleCollapse, onClose }) => {
    return (react_1.default.createElement(core_1.Paper, { className: "ml-3 overflow-hidden pointer-events-auto", style: {
            width: window.width,
        }, square: false, elevation: 5 },
        react_1.default.createElement(WindowTitleBar, { title: window.title, onClick: () => onToggleCollapse(window.id), onClose: () => onClose(window.id) }),
        react_1.default.createElement(core_1.Collapse, { in: !window.isCollapsed },
            react_1.default.createElement(core_1.Divider, null),
            react_1.default.createElement("div", { className: "pt-2 ph-2", style: {
                    height: window.height,
                } }, window.content))));
};
const WindowTitleBar = ({ title, onClick, onClose }) => {
    return (react_1.default.createElement("div", { className: "pa-2 flex justify-between items-center cursor-pointer", onClick: onClick },
        react_1.default.createElement(core_1.Typography, { variant: "h4" }, title),
        react_1.default.createElement(core_1.IconButton, { size: "small", onClick: onClose },
            react_1.default.createElement(icons_1.CloseRounded, null))));
};
const reducer = ({ windows, nextId }, action) => {
    switch (action.type) {
        case 'open':
            const newWindow = Object.assign({ id: nextId, isCollapsed: false }, action.window);
            action.windowIdCallback(newWindow.id);
            return {
                windows: [...windows, newWindow],
                nextId: nextId + 1,
            };
        case 'close':
            return {
                windows: windows.filter((window) => window.id !== action.windowId),
                nextId,
            };
        case 'toggleCollapse':
            return {
                windows: windows.map((window) => window.id === action.windowId
                    ? Object.assign(Object.assign({}, window), { isCollapsed: !window.isCollapsed }) : window),
                nextId,
            };
    }
};
